import { AreaListMenu } from "./AreaListMenu";
import React from "react";
import {useDebouncedSearch, useQueryWithPagination} from "../../utils/Hooks";
import { AxiosAreasAPI } from "../Api";
import { AreaListRoutes } from "../Routes";

export function AreaListLayout() {
  const [search, debouncedSearch, setSearch] = useDebouncedSearch();
  const areaData = useQueryWithPagination({
    queryKey: ["area-list-layout", debouncedSearch],
    queryFn: AxiosAreasAPI.getAll,
    expand: ["_links.parents.parent"], 
    search: debouncedSearch
  });

  return (
    <div>
      <AreaListMenu
        search={search}
        setSearch={setSearch}
        reload={areaData.refetch}
      />
      <AreaListRoutes search={debouncedSearch} areaData={areaData} />
    </div>
  );
}
